import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { Button } from './Button'
import { styled } from '@mui/material/styles'
import i18n from '../i18n'

const StyledBox2 = styled(Box)(() => ({
  justifyContent: 'center',
  height: '62vh',
  border: '1px dashed grey',
  alignItems: 'center',
  width: '100%',
  borderRadius: 10,
  display: 'flex',
  flexDirection: 'column'
}))

type Item = {
  title: string
  action?: () => void
}

type Props = {
  titleMessage?: string | null
  subTitleMessage?: string | null
  buttons?: Item[]
}

const emptyTitle = i18n.t('general.emptyListTitle')
const emptyMessage = i18n.t('general.emptyListMessage')

export function TreatEmpty ({ titleMessage = null, subTitleMessage = null, buttons }: Props) {
  return (
    <StyledBox2 marginTop={2}>
      <Stack sx={{ overflow: 'auto' }}>
        <Typography variant="h5">{ titleMessage ?? emptyTitle}</Typography>
      </Stack>
      <Stack>
        <Typography variant='subtitle2'>{subTitleMessage ?? emptyMessage}</Typography>
      </Stack>
      {buttons && <Stack direction="row" justifyContent="center" alignItems="baseline" spacing={4} padding={4}>
        {buttons?.map(({ title, action }, key) =>
          <Button title={title} onClick={ action } key={key}></Button>
        )}
      </Stack>}
    </StyledBox2>
  )
}
